// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._15ufbpv0 {
  width: 100%;
}
@media screen and (min-width: 768px) {
  ._15ufbpv0 {
    width: calc(33.33% - 2px);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["._15ufbpv0 {\n  width: 100%;\n}\n@media screen and (min-width: 768px) {\n  ._15ufbpv0 {\n    width: calc(33.33% - 2px);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
